import React from 'react';
import { Field } from '../../components/Form';
import FormModal from '../../components/FormModal';
import request from '../../utils/network/request';

const SUBDOMAIN_REGEX = /^\w[\w-]+\w$/;

interface ZendeskEnableModalProps {
  close: () => void;
  redirectUrl: string | null;
}

const ZendeskEnableModal = ({
  close,
  redirectUrl,
}: ZendeskEnableModalProps) => {
  const handleSubmit = async ({ host }: { host: string }) => {
    const params = { host: `${host}.zendesk.com`, redirect_url: redirectUrl };

    const data = await request('/api/zendesk/integrate', 'GET', params);
    document.location = (data as { url: string }).url;
  };

  return (
    <FormModal<{ host: string }>
      title="Enable Zendesk"
      close={close}
      width={425}
      form={{
        initialValues: { host: '' },
        onSubmit: handleSubmit,
        validate: ({ host }) =>
          SUBDOMAIN_REGEX.test(host) ? {} : { host: 'Enter a valid subdomain' },
      }}
      footer={{
        submitButton: { text: 'Authorize Zendesk' },
      }}
    >
      <Field
        name="host"
        label="Enter your Zendesk subdomain:"
        placeholder="subdomain"
        prepend="https://"
        append=".zendesk.com"
        required
      />
    </FormModal>
  );
};

export default ZendeskEnableModal;
